<template>
  <div class="UEditor">
      <script :id="id" type="text/plain"></script>
  </div>
</template>

<script>
window.UEDITOR_HOME_URL = "/static/ueditor/"
export default {
  props: {
      id: {
          type: String
      },
      defaultMsg: {
          type: String,
          default: 'haha'
      },
      config: {
          type: Object,
          default: {}
      },
  },
  data () {
    return {
      editor: null
    }
  },
  watch: {
    config: {
      handler (newValue, oldValue) {
        // console.log('---------', this.editor, newValue, oldValue);
        if (!this.editor) {
          this.editor = UE.getEditor(this.id, this.config);
        }
        if (newValue.readonly) {
          this.editor.ready(() => {
            this.editor.setDisabled();
          });
        }
      },
      deep: true
    }
  },
  mounted () {
      if (!this.editor) {
        this.editor = UE.getEditor(this.id, this.config);
      }
  },
  methods: {
      getUEContent () {
          return this.editor.getContent();
      },
      setUEContent (content) {
          // console.log(this.editor.setContent);
          this.editor.ready(() => {
            this.editor.setContent(content);
          });
      }
  },
  destroyed () {
      this.editor.destroy();
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/ueditor/index.vue